<template>
  <v-dialog
    v-model="visible"
    :width="$vuetify.breakpoint.smAndDown ? '90%' : '50%'"
    scrollable
    persistent
    content-class="elevation-0"
  >
    <v-card class="hide-scrollbar pa-0 ma-0" :class="$vuetify.breakpoint.mdAndUp ? 'transparent' : 'rounded-xl'">
      <v-card-text style="z-index: 100" class="ma-0 mt-n1" :class="$vuetify.breakpoint.mdAndUp ? 'px-8' : 'pa-0'">
        <v-card-title class="hidden-sm-and-up">
          <v-btn icon class="mr-3" :href="'tel:' + bbr.handy" :disabled="!bbr.handy">
            <v-icon>phone</v-icon>
          </v-btn>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                class="mr-3"
                target="_blank"
                :href="'https://wa.me/' + bbr.handy.replace(/\s+/g, '')"
                :disabled="!bbr.handy"
                ><v-icon>mdi-whatsapp</v-icon></v-btn
              >
            </template>
            <span>
              <v-card class="transparent" flat dark width="200px"> Whatsapp </v-card>
            </span>
          </v-tooltip>
          <v-btn icon :href="'mailto:' + bbr.email" :disabled="!bbr.email"><v-icon>mail</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-row no-gutters>
          <v-col cols="12" class="mt-4 mb-n16 pb-n8 text-center">
            <v-avatar size="172" class="white" :class="$vuetify.breakpoint.mdAndUp ? 'elevation-12' : ''">
              <v-avatar @click="showImage = true" style="z-index: 1000" size="156" class="white elevation-0">
                <v-img
                  class="ma-4 profilbild"
                  max-height="156"
                  :src="bbr.bildAhnengalerie500"
                  v-if="bbr.bildAhnengalerie500"
                >
                  <template v-slot:placeholder>
                    <v-progress-circular size="148" width="7" indeterminate color="primary"></v-progress-circular>
                  </template>
                </v-img>
                <v-icon light x-large v-else class="grey lighten-3">person</v-icon>
              </v-avatar>
            </v-avatar>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-card rounded :flat="!$vuetify.breakpoint.mdAndUp" class="rounded-xl mt-n8 pt-8 pt-md-0">
              <v-card-title class="hidden-sm-and-down">
                <v-btn icon v-if="allowEdit" class="green mr-2" dark @click="showBbrEdit = true"
                  ><v-icon>edit</v-icon></v-btn
                >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      class="mr-2"
                      :href="'https://wa.me/' + bbr.handy.replace(/\s+/g, '')"
                      :disabled="!bbr.handy"
                      ><v-icon>mdi-whatsapp</v-icon></v-btn
                    >
                  </template>
                  <span>
                    <v-card class="transparent" flat dark> Whatsapp </v-card>
                  </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon :href="'mailto:' + bbr.email" target="_blank" :disabled="!bbr.email"
                      ><v-icon>mail</v-icon></v-btn
                    >
                  </template>
                  <span>
                    <v-card class="transparent" flat dark> Mail schreiben </v-card>
                  </span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
              </v-card-title>
              <v-card-title class="text-center pt-16 pt-md-8 d-flex justify-center">
                <v-col cols="12" class="pb-0">{{ bbr.titel }} {{ bbr.vorname }} {{ bbr.nachname }}</v-col>
                <v-col cols="12" class="pt-0">
                  <v-chip
                    small
                    label
                    style="height: 48px"
                    v-for="charge in bbr.chargen"
                    :key="charge.semester"
                    pill
                    class="mr-1"
                  >
                    {{ charge.charge }}
                    <!-- <v-divider vertical class="mx-2"></v-divider> -->
                    <br />
                    {{ charge.semester }}
                  </v-chip>
                </v-col>
              </v-card-title>
              <v-row no-gutters class="ma-2">
                <v-col cols="12" md="6" class="py-1 px-1">
                  <v-list-item
                    dense
                    v-for="(feld, index) in felder.slice(
                      0,
                      Math.ceil(this.felder.filter((item) => item.show).length / 2)
                    )"
                    :key="index"
                  >
                    <!-- <v-list-item-avatar class="pr-4 ma-0">
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-item-avatar> -->
                    <v-list-item-content class="text-left">
                      <v-list-item-subtitle v-if="showHelp" class="font-weight-bold">{{
                        feld.label
                      }}</v-list-item-subtitle>
                      <span v-if="bbr[feld.value]">
                        <span v-if="feld.type === 'Date' && feld.value === 'geburtsdatum'"
                          >{{ $filters.date(bbr[feld.value], "DD.MM.YYYY") }} ({{
                            calculateAge(bbr[feld.value])
                          }}
                          Jahre)</span
                        >
                        <span v-else-if="feld.type === 'Date'">{{ $filters.date(bbr[feld.value], "DD.MM.YYYY") }}</span>
                        <span v-else> {{ bbr[feld.value] }}</span>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="6" class="py-1 px-1">
                  <v-list-item
                    dense
                    v-for="(feld, index) in felder.slice(Math.ceil(this.felder.filter((item) => item.show).length / 2))"
                    :key="index"
                  >
                    <!-- <v-list-item-avatar class="pr-4 ma-0">
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-list-item-avatar> -->
                    <v-list-item-content class="text-left">
                      <v-list-item-subtitle v-if="showHelp" class="font-weight-bold">{{
                        feld.label
                      }}</v-list-item-subtitle>
                      <span v-if="bbr[feld.value]">
                        <span v-if="feld.type === 'Date' && feld.value === 'geburtsdatum'">{{
                          $filters.date(bbr[feld.value], "DD.MM.YYYY")
                        }}</span>
                        <span v-else-if="feld.type === 'Date'">{{ $filters.date(bbr[feld.value], "DD.MM.YYYY") }}</span>
                        <span v-else-if="feld.type === 'Leibvater'">{{
                          $filters.user(bbr[feld.value], bundesbruder)
                        }}</span>
                        <span v-else-if="feld.type === 'Verbindungen'">
                          <span v-for="(i, num) in bbr[feld.value]" :key="num">
                            {{ i }}
                          </span>
                        </span>
                        <span v-else>{{ bbr[feld.value] }}</span>
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
              <v-divider></v-divider>

              <!-- <v-card-actions class="mb-6">
            
            <v-spacer></v-spacer>
            <v-btn rounded text @click="close()">Schließen</v-btn>
          </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showImage" width="30%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-divider></v-divider>

        <v-card-text class="pa-2 ma-0">
          <v-img :src="bbr.bildAhnengalerie500" width="100%"></v-img>
        </v-card-text>

        <v-card-actions class="mb-6">
          <v-spacer></v-spacer>
          <v-btn text @click="showImage = false">Schließen</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialogKontaktEdit
      v-if="showBbrEdit"
      :visibleEdit.sync="showBbrEdit"
      :bbr="bbr"
      @close="showBbrEdit = false"
    ></dialogKontaktEdit>

    <v-dialog v-model="showStammbaum" width="100%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title>
          Leibfamilie - {{ bbr.titel }} {{ bbr.vorname }} {{ bbr.nachname }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showStammbaum = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-0 ma-0">
          <stammbaum :dense="denseStammbaum" :bbr="bbr" :currentBbr="bbr.id"></stammbaum>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mb-6">
          <v-btn v-if="denseStammbaum" icon @click="denseStammbaum = !denseStammbaum"
            ><v-icon>zoom_out_map</v-icon></v-btn
          >
          <v-btn v-else icon @click="denseStammbaum = !denseStammbaum"><v-icon>zoom_in_map</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="showStammbaum = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import stammbaum from "@/module/submodule/stammbaum";
  export default {
    components: {
      stammbaum,
    },
    props: ["bbr", "visible"],
    data() {
      return {
        date: "",
        menu1: "",
        menu2: "",
        menu3: "",
        showStammbaum: false,
        denseStammbaum: true,
        selectPicture: "",
        uploadValue: "",
        img1: "",
        imageData: "",
        showBbrEdit: false,
        message: "",
        showHelp: true,
        showImage: false,
      };
    },
    computed: {
      felder() {
        const kontaktfelder = this.$store.getters["einstellungen/einstellung"]("kontaktfelder");
        let neuFelder;
        if (kontaktfelder === undefined) {
          neuFelder = {};
        } else {
          neuFelder = kontaktfelder.neuFelder.filter((item) => item.show);
        }
        return neuFelder;
      },
      bundesbruder() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      leibfamilie() {
        // let leibfamilie = {}
        let grunder;
        let bbr = this.bbr;
        while (!grunder) {
          if (bbr.leibvater) {
            bbr = this.$store.getters["bbrbbr/bbr"](bbr.leibvater);
            console.log(bbr.nachname);
          } else {
            grunder = bbr;
          }
        }
        let leibfamilie = {
          bbr: grunder,
          sohn: this.getLeibsohn(bbr.id),
        };
        console.log(leibfamilie);
        return leibfamilie;
      },
      allowEdit() {
        let seiten = this.$store.getters["einstellungen/einstellung"]("rollen");
        let bbr = this.$store.state.bbrbbr.bbrbbr.find((d) => d.anmeldeID === this.$firebase.auth().currentUser.uid);
        let variable = false;
        if (seiten !== undefined) {
          seiten.seiten.forEach((item) => {
            if (item.gruppe === "Chargen" || item.gruppe === "AHV" || item.gruppe === "HBV") {
              if (item.berechtigt.indexOf(bbr.id) >= 0 || bbr.id === "PBChUyAy7HWowQR4HlP3") {
                variable = true;
              }
            }
          });
        }
        return variable;
      },
      getAlter() {
        const birthDate = new Date(this.bbr.geburtsdatum);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      getCouleurAlter() {
        const birthDate = new Date(this.bbr.receptionsdatum);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age * 2;
      },
    },
    methods: {
      calculateAge(birthDate) {
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const m = today.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
          age--;
        }
        return age;
      },
      getLeibsohn(bbrID) {
        let leibsohn = [];
        this.$store.getters["bbrbbr/nurBbrbbr"].forEach((bbr) => {
          if (bbr.leibvater === bbrID) {
            leibsohn.push({
              bbr,
              sohn: this.getLeibsohn(bbr.id),
            });
          }
        });
        return leibsohn;
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style>
  .profilbild .v-image__image--cover {
    background-position: top !important;
  }
  .hide-scrollbar {
    overflow: auto;
    scrollbar-width: none; /* Für Firefox */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none; /* Für Chrome, Safari und Edge */
  }
</style>



// WEBPACK FOOTER //
// dialogKontakt.vue?268d6916